import React, { useState, useRef, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  Box,
  Button,
  Card,
  Chip,
  Typography,
  TextField,
  Tooltip
} from "@material-ui/core"
import Autocomplete from "@material-ui/lab/Autocomplete"
import LoaderButton from "../../../../../../components/LoaderButton"
import {
  addEmail,
  addEmailGroup,
  getEmailsWithTags
} from "actions/organization"
import { openSnackBar } from "actions/snack-bar"
import { useFormik } from "formik"
import * as Yup from "yup"
import useStyles from "./styles"

const CommunicationNewEmail = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const inputRef = useRef()
  const { id, tags = [], emailsWithTags = [] } = useSelector(
    state => state.organization.currentOrg
  )
  const [loading, setLoading] = useState(false)
  const [autocompleteRefresh, setAutocompleteRefresh] = useState(false)
  //array of existing emails
  const [emailsArray, setEmailsArray] = useState([])

  useEffect(() => {
    if (emailsWithTags.length > 0) {
      setEmailsArray(emailsWithTags.map(x => x.email))
    }
  }, [emailsWithTags])

  const formik = useFormik({
    initialValues: {
      email: "",
      tags: []
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Please enter a valid email")
        .required("Email is required"),
      tags: Yup.array()
        .min(1, "Please add at least one tag")
        .required("At least one tag is required")
    }),
    onSubmit: values => {
      setLoading(true)
      dispatch(addEmail(id, values.email))
        .then(response => {
          dispatch(addEmailGroup(id, response.data.emailId, values.tags)).then(
            response => {
              setAutocompleteRefresh(true)
              dispatch(getEmailsWithTags(id))
              dispatch(openSnackBar({ message: "Email added." }))
            }
          )
        })
        .catch(() => {
          dispatch(openSnackBar({ message: "Error adding email." }))
        })
        .finally(() => {
          setLoading(false)
          formik.resetForm()
          setAutocompleteRefresh(false)
          setEmailsArray(emailsWithTags.map(x => x.email))
        })
    }
  })

  const handleTagChange = (event, newValue) => {
    const newTags = newValue.map(value => value.id)
    formik.setFieldValue("tags", newTags)
  }

  return (
    <Card className={classes.root}>
      <form className={classes.addEmailForm} onSubmit={formik.handleSubmit}>
        <TextField
          inputRef={inputRef}
          id="email"
          name="email"
          label="Enter new email"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.email}
          error={Boolean(formik.touched.email && formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
          disabled={loading}
        />
        <Autocomplete
          key={autocompleteRefresh}
          className={classes.tagsInput}
          multiple
          size="small"
          options={tags.sort((a, b) => a.name.localeCompare(b.name))}
          getOptionLabel={option => option.name}
          onChange={handleTagChange}
          disabled={loading}
          classes={{
            listbox: classes.listBox,
            popupIndicator: classes.popupIndicator,
            tag: classes.rootTag
          }}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label="Add Tags"
              placeholder=""
              error={Boolean(formik.touched.tags && formik.errors.tags)}
              helperText={formik.touched.tags && formik.errors.tags}
            />
          )}
        />
        <Tooltip
          title={
            emailsArray &&
            emailsArray.length > 0 &&
            emailsArray.includes(formik.values.email)
              ? "Email is in use"
              : ""
          }
          placement="bottom"
        >
          <div>
            <LoaderButton
              onClick={formik.handleSubmit}
              working={loading}
              variant="contained"
              color="primary"
              disabled={
                emailsArray &&
                emailsArray.length > 0 &&
                emailsArray.includes(formik.values.email)
              }
            >
              Add
            </LoaderButton>
          </div>
        </Tooltip>
      </form>
    </Card>
  )
}

export default CommunicationNewEmail



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Communication/CommunicationEmail/CommunicationNewEmail/index.jsx